module.exports = __webpack_public_path__ + "static/gk-20e57a830a6abfdaa632a20ca4408e09.jpg";